import React from "react";
import { Form } from "react-bootstrap";
import { useField } from "formik";

/**
 * This is called manual because the onChange event function is set directly on the field where it is been used
 * @param {string} props.label - display checkbox description/name/title
 * @param {string} props.name - field name of checkbox
 * @param {boolean} props.defaultChecked - html attribute for default checked
 * @param {function} props.onChange - event action to set checkbox to either true or false
 * @returns {JSX}
 */
const BCheckBorderedBoxManual = ({ label, name, defaultChecked, onChange, ...props }) => {
    const [field] = useField(props);
    return (
        <>
            <Form.Group>
                <div className="checkbox d-inline checkbox-fill">
                    <Form.Control
                        {...field}
                        {...props}
                        type="checkbox"
                        name={name}
                        id={name}
                        defaultChecked={defaultChecked}
                        onChange={onChange}
                    />
                    <Form.Label htmlFor={name} className="cr">
                        {label}
                    </Form.Label>
                </div>
            </Form.Group>
        </>
    );
};

BCheckBorderedBoxManual.defaultProps = {
    defaultChecked: false
};

export default BCheckBorderedBoxManual;
